import { CorrelationId } from "@shared/telemetry/correlationId";
import { create } from "zustand";

interface CurrentInstanceIdStore {
  instanceId: string | undefined;
  setCurrentInstanceId: (instanceId: string) => void;
  unsetCurrentInstanceId: () => void;
  correlationId: CorrelationId | undefined;
  setCorrelationId: (correlationId: CorrelationId) => void;
}
export const useCurrentInstanceId = create<CurrentInstanceIdStore>((set) => ({
  instanceId: undefined,
  setCurrentInstanceId: (instanceId: string) => set({ instanceId }),
  unsetCurrentInstanceId: () => set({ instanceId: undefined }),
  correlationId: undefined,
  setCorrelationId: (correlationId: CorrelationId) => set({ correlationId }),
}));
